import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import initSentry from './services/sentry';
import { installChunkReloadGuard } from './utils/lazyRetry';
import './styles/index.css';
// Code-editor stylesheet for VariantEditorModal — loaded at boot so the lazy
// modal chunk does not depend on a separate hashed CSS preload (stale-bundle
// 404s after redeploy break "Add variant").
import '@uiw/react-textarea-code-editor/dist.css';

// Fire-and-forget Sentry init. No-op when VITE_SENTRY_DSN is unset.
initSentry();

// Auto-reload once when a chunk import fails after a redeploy. See
// utils/lazyRetry.js for the rationale.
installChunkReloadGuard();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
